export default __webpack_public_path__ + "static/media/settingicon.4764cf92.svg";